module.exports = __webpack_public_path__ + "img/hood length.ffea81ac.png";